import compact from 'lodash/compact';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

import { getUserTimezoneAbbr } from '@app/dashboard/dispatch/dispatch-utils';
import { getFormattedTimeWindow } from '@app/dashboard/dispatch/manage-dispatch/manage-dispatch.utils';

import { IDispatchAddress } from '@app/dashboard/dispatch/dispatch.interfaces';

export interface IDetailCardAttachment {
  id: number;
  heading: string;
  name: string;
}

export interface ITimeWindow {
  startDatetime: string;
  endDatetime: string;
}

export interface IDetailCardContent {
  label: string;
  text?: string;
  link?: string;
  address?: IDispatchAddress;
  attachments?: IDetailCardAttachment[];
  bulletList?: string[][];
  timeWindow?: ITimeWindow;
  currencyType?: string;
  type: DETAIL_CARD_CONTENT_TYPE;
}

export enum DETAIL_CARD_CONTENT_TYPE {
  TEXT,
  CURRENCY,
  ADDRESS,
  ATTACHMENTS,
  BULLET_TEXTS,
  PHONE_NUMBER,
  EMAIL,
  TIME_WINDOW,
}

@Component({
  selector: 'detail-card',
  templateUrl: './detail-card.component.html',
  styleUrls: ['./detail-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailCardComponent {
  @Input() public cardHeader: string | TemplateRef<void>;
  @Input() public userTimeZone: string;
  @Input() public cardContent: IDetailCardContent[];
  @Input() public isBordered: boolean = true;
  @Output() public onAttachmentClick: EventEmitter<number> = new EventEmitter<number>();
  public detailCardContentType: typeof DETAIL_CARD_CONTENT_TYPE = DETAIL_CARD_CONTENT_TYPE;
  public getFormattedTimeWindow: typeof getFormattedTimeWindow = getFormattedTimeWindow;

  public get userTimezoneAbbr(): string {
    return getUserTimezoneAbbr(this.userTimeZone);
  }

  public getFormattedAddress(address: IDispatchAddress): string {
    if (!address) return null;
    const { address1, city, state, zip } = address;
    return compact([address1, city, state, zip]).join(', ');
  }

  public attachmentClick(attachmentId: number): void {
    this.onAttachmentClick.emit(attachmentId);
  }
}
